module.exports = __webpack_public_path__ + "img/6.6ba138b0.png";